import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { SpanKind, SpanStatusCode, createSpanFunction, getTraceParentHeader, isSpanContextValid } from "@azure/core-tracing";
import { logger } from "../log";
var createSpan = createSpanFunction({
  packagePrefix: "",
  namespace: ""
});
/**
 * Creates a policy that wraps outgoing requests with a tracing span.
 * @param tracingOptions - Tracing options.
 * @returns An instance of the {@link TracingPolicy} class.
 */

export function tracingPolicy() {
  var tracingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    create: function create(nextPolicy, options) {
      return new TracingPolicy(nextPolicy, options, tracingOptions);
    }
  };
}
/**
 * A policy that wraps outgoing requests with a tracing span.
 */

export var TracingPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(TracingPolicy, _BaseRequestPolicy);

  var _super = _createSuper(TracingPolicy);

  function TracingPolicy(nextPolicy, options, tracingOptions) {
    var _this;

    _classCallCheck(this, TracingPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.userAgent = tracingOptions.userAgent;
    return _this;
  }

  _createClass(TracingPolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var span, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (request.tracingContext) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._nextPolicy.sendRequest(request));

              case 2:
                span = this.tryCreateSpan(request);

                if (span) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this._nextPolicy.sendRequest(request));

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return this._nextPolicy.sendRequest(request);

              case 8:
                response = _context.sent;
                this.tryProcessResponse(span, response);
                return _context.abrupt("return", response);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](5);
                this.tryProcessError(span, _context.t0);
                throw _context.t0;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 13]]);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: "tryCreateSpan",
    value: function tryCreateSpan(request) {
      var _a;

      try {
        // Passing spanOptions as part of tracingOptions to maintain compatibility @azure/core-tracing@preview.13 and earlier.
        // We can pass this as a separate parameter once we upgrade to the latest core-tracing.
        var _createSpan = createSpan("HTTP ".concat(request.method), {
          tracingOptions: {
            spanOptions: Object.assign(Object.assign({}, request.spanOptions), {
              kind: SpanKind.CLIENT
            }),
            tracingContext: request.tracingContext
          }
        }),
            span = _createSpan.span; // If the span is not recording, don't do any more work.


        if (!span.isRecording()) {
          span.end();
          return undefined;
        }

        var namespaceFromContext = (_a = request.tracingContext) === null || _a === void 0 ? void 0 : _a.getValue(Symbol.for("az.namespace"));

        if (typeof namespaceFromContext === "string") {
          span.setAttribute("az.namespace", namespaceFromContext);
        }

        span.setAttributes({
          "http.method": request.method,
          "http.url": request.url,
          requestId: request.requestId
        });

        if (this.userAgent) {
          span.setAttribute("http.user_agent", this.userAgent);
        } // set headers


        var spanContext = span.spanContext();
        var traceParentHeader = getTraceParentHeader(spanContext);

        if (traceParentHeader && isSpanContextValid(spanContext)) {
          request.headers.set("traceparent", traceParentHeader);
          var traceState = spanContext.traceState && spanContext.traceState.serialize(); // if tracestate is set, traceparent MUST be set, so only set tracestate after traceparent

          if (traceState) {
            request.headers.set("tracestate", traceState);
          }
        }

        return span;
      } catch (error) {
        logger.warning("Skipping creating a tracing span due to an error: ".concat(error.message));
        return undefined;
      }
    }
  }, {
    key: "tryProcessError",
    value: function tryProcessError(span, err) {
      try {
        span.setStatus({
          code: SpanStatusCode.ERROR,
          message: err.message
        });

        if (err.statusCode) {
          span.setAttribute("http.status_code", err.statusCode);
        }

        span.end();
      } catch (error) {
        logger.warning("Skipping tracing span processing due to an error: ".concat(error.message));
      }
    }
  }, {
    key: "tryProcessResponse",
    value: function tryProcessResponse(span, response) {
      try {
        span.setAttribute("http.status_code", response.status);
        var serviceRequestId = response.headers.get("x-ms-request-id");

        if (serviceRequestId) {
          span.setAttribute("serviceRequestId", serviceRequestId);
        }

        span.setStatus({
          code: SpanStatusCode.OK
        });
        span.end();
      } catch (error) {
        logger.warning("Skipping tracing span processing due to an error: ".concat(error.message));
      }
    }
  }]);

  return TracingPolicy;
}(BaseRequestPolicy);